import type { Order, Payment } from "@graphql/generated/types";
import { paymentMethodMap } from "@lib/constants/payment";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";

export function getSuccessPayment(order: Order): Payment | null {
    return (
        order?.paymentInfo?.payments
            .filter(
                (payment) =>
                    payment?.transactions?.filter(
                        (transaction) =>
                            transaction?.type === "Authorization" &&
                            transaction?.state === "Success"
                    ).length !== 0
            )
            .find((payment) => payment) || null
    );
}

export function getReadablePaymentMethod(paymentMethod: string): string {
    if (!paymentMethod) {
        return "";
    }

    const lowerCasePaymentMethod = paymentMethod.toLowerCase();
    for (const key of Object.keys(paymentMethodMap)) {
        if (lowerCasePaymentMethod.includes(key)) {
            return paymentMethodMap[key];
        }
    }

    return "";
}

export function logError(message: string, id: string): void {
    Logger.info(ServiceType.ADYEN, `PAYMENT: ${message} for cartId: ${id}`, {
        tag: LogTag.PAYMENT,
        cartId: id,
    });
}
